module.exports = __webpack_public_path__ + "/login_ui/img/hr-3b73614df8d4f1892c421616d7761b35.svg";